"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ControllerDropLocation;
(function (ControllerDropLocation) {
    ControllerDropLocation[ControllerDropLocation["UPPER_PART"] = 0] = "UPPER_PART";
    ControllerDropLocation[ControllerDropLocation["IN_ROW"] = 1] = "IN_ROW";
    ControllerDropLocation[ControllerDropLocation["LOWER_ROW"] = 2] = "LOWER_ROW";
})(ControllerDropLocation = exports.ControllerDropLocation || (exports.ControllerDropLocation = {}));
//# sourceMappingURL=controller-drop-location.enum.js.map